import { useLoggedinUser } from "./useLoggedinUser";
import useSWR from "swr";
import teamUsers from "../clients/teamUsers";
import teamUsersClient from "../clients/teamUsers";
import { useToastNotification } from ".";
import { TeamUser } from "lib/types";
import { PermissionLevels } from "lib/types";

const fetcher = async (): Promise<any> => {
  try {
    const { data } = await teamUsers.getUsers();
    return data;
  } catch (err) {
    throw err;
  }
}

export const useTeamMembers = () => {
  const { data: user } = useLoggedinUser();
  const { data: response, error, isValidating, mutate } = useSWR(user?.verified ? `v1/team-users/members` : null, fetcher);
  const { errorToast, successToast } = useToastNotification();

  const data = response || [];

  const deleteTeamMember = async (userId: string) => {
    try {
      const teamUsers = data.filter((teamUser: TeamUser) => teamUser.user.id === userId);
      await mutate(teamUsers, false);
      await teamUsersClient.removeUser(userId);
      await mutate();
    } catch (err) {
      errorToast({ title: 'Error', description: 'Could not remove team member' })
    }
  }

  const updateTeamMember = async (userId: string, permissions: PermissionLevels.ADMIN | PermissionLevels.MEMBER) => {
    try {
      const teamUser = data.find((teamUser: TeamUser) => teamUser.user.id === userId);
      teamUser.permissions = permissions;
      await mutate(data, false);

      await teamUsersClient.updateUser(userId, permissions);
      await mutate();

      successToast({ description: `${teamUser.user.first_name} ${teamUser.user.last_name} updated to ${permissions}` });
    } catch (err) {
      errorToast({ title: 'Error', description: 'Could not update team member' })
    }
  }

  return {
    data,
    error,
    isLoading: !response && !error,
    isValidating,
    mutate,
    deleteTeamMember,
    updateTeamMember
  }
}
